import { AccredibleTooltipDirection } from '@accredible-frontend-v2/new-components/tooltip';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Renderer2,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'accredible-truncate-text',
  templateUrl: 'truncate-text.component.html',
  styleUrls: ['./truncate-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccredibleTruncateTextComponent implements AfterViewInit {
  @Input()
  text = '';
  @Input()
  maxLines = 1;
  @Input()
  tooltipDirection: AccredibleTooltipDirection = AccredibleTooltipDirection.TOP;

  isTruncated = false;

  @ViewChild('truncatedTextRef') truncatedTextRef!: ElementRef;

  constructor(private readonly _renderer: Renderer2, private readonly _cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this._handleTruncationUpdate();
  }

  private _handleTruncationUpdate(): void {
    const container = this.truncatedTextRef?.nativeElement;

    if (!container) {
      return;
    }

    this._renderer.setStyle(container, '-webkit-line-clamp', `${this.maxLines}`);
    this.isTruncated = container.scrollHeight > container.clientHeight;
    this._cdr.detectChanges();
  }
}
